import "./SinglePostTemplate.module.css"
import EnTete from "@/reusable_sections/Header"
import SinglePostTemplate from "./sections/SinglePostTemplate"
import PiedDePage from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <EnTete />
      <SinglePostTemplate />
      <PiedDePage />
    </div>
  )
}
